import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=1990df4a&scoped=true"
import script from "./Hint.vue?vue&type=script&lang=ts"
export * from "./Hint.vue?vue&type=script&lang=ts"
import style0 from "./Hint.vue?vue&type=style&index=0&id=1990df4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990df4a",
  null
  
)

export default component.exports